import { Controller } from "stimulus"
import { initSelect2 } from "../../select2_init";

// data attribute: vehicle-constraints--form
export default class extends Controller {
  connect() {
    const $ = window.jQuery
    initSelect2('#vehicle_constraint_vehicle_make_id', { placeholder: "Select a make..." });
    initSelect2('#vehicle_constraint_vehicle_model_id', { placeholder: "Select a model..." });
    initSelect2('#vehicle_constraint_underwriter_id', { placeholder: "Select an underwriter..." });
    $('#vehicle_constraint_vehicle_make_id').on("change.vcForm", (event) => {
      this.fetchModels(event)
    })
  }

  destroySelect2(selector) {
    const $ = window.jQuery
    if (!$ || !$.fn.select2) return
    $(selector).each((_, el) => {
      const $el = $(el)
      if ($el.data("select2")) $el.select2("destroy")
    })
  }

  fetchModels(event) {
    const vehicleModel = document.querySelector('#vehicle_constraint_vehicle_model_id');
    console.log(event);
    vehicleModel.innerHTML = '';
    vehicleModel.disabled = true;
    const vehicleMakeId = event.target.value;
    if (vehicleMakeId) {
      fetch(`/make_models/${vehicleMakeId}/fetch_models?fetch_all=true`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      })
      .then(response => response.json())
        .then(data => {
          vehicleModel.disabled = false;
          vehicleModel.innerHTML = data.models.map(model => `<option value="${model.id}">${model.name}</option>`).join('');
        })
        .catch(error => {
          console.error('Error fetching models:', error);
        });
    }
  }
}